import PlaceCell from './PlaceCell';

export default PlaceCell;
